module.exports = __webpack_public_path__ + "img/icone-seta.eddcec17.svg";